import EnvioInformes from 'components/envioInformes/EnvioInformes'
import React from 'react'
import { Col, Row } from 'reactstrap'

function ViewEnvioInformes() {
  return (
    <Row>
        <Col>
            <EnvioInformes />
        </Col>

    </Row>
  )
}

export default ViewEnvioInformes